module.exports = __webpack_public_path__ + "static/media/manageServices.ea170a43.svg";